// Closed lists for the Step-3 extract editor. Duplicated here (not imported
// from catalog/upsertItem) so the old catalog UI stays independently deletable.
import { BED_TYPES } from '../itemTypes';

export const PRICE_UNITS = [
    { value: 0, label: 'Per Item' },
    { value: 1, label: 'Per Gallon' },
    { value: 2, label: 'Per Square Foot' },
];

// Mirrors textureVariant.js allowedType options.
export const ALLOWED_TYPES = [
    { value: 'Wall', label: 'Walls' },
    { value: 'Floor', label: 'Floor' },
    { value: 'CribMattress', label: 'Crib sheet' },
    { value: 'CribBlanket', label: 'Crib hanging blanket' },
    { value: 'ToddlerBedMattress', label: 'Toddler bed sheet' },
    { value: 'ToddlerBedBlanket', label: 'Toddler bed blanket' },
    { value: 'TwinBedMattress', label: 'Twin bed sheet' },
    { value: 'TwinBedBlanket', label: 'Twin bed blanket' },
    { value: 'QueenBedMattress', label: 'Queen bed sheet' },
    { value: 'QueenBedBlanket', label: 'Queen bed blanket' },
    { value: 'BassinetMattress', label: 'Bassinet sheet' },
    { value: 'BassinetBlanket', label: 'Bassinet blanket' },
];

// Texture-type items carry allowedType + specular/uSize/vSize/repeat. A curtain's
// swatch instead carries the panel material params (opacity + colors) and the
// fabric's pattern repeat size; a pillow's cover only its stated width/height.
export const TEXTURE_ITEM_TYPES = ['Texture', 'WallPrint', 'Pillow', 'Curtain'];

export const CURTAIN_COLOR_FIELDS = [
    { key: 'diffuseColor', label: 'Diffuse (tint)', fallback: '#ffffff' },
    { key: 'specularColor', label: 'Specular (shine)', fallback: '#000000' },
    { key: 'emissiveColor', label: 'Emissive', fallback: '#000000' },
    { key: 'ambientColor', label: 'Ambient', fallback: '#ffffff' },
];

// Only resizable items carry a ResizableConfig size — floor/wall items and beds
// (mirrors the pipeline's SIZE_ITEM_TYPES; beds resize like floor items).
export const SIZE_ITEM_TYPES = ['FloorItem', 'WallItem', ...BED_TYPES];

// The resize axis pre-selected in Step 3 (mirrors the pipeline's defaultResizeAxes):
// one calibrated axis, the rest follow the model — beds by width, the rest by height.
export const defaultResizeAxes = (itemType) => (BED_TYPES.includes(itemType) ? ['width'] : ['height']);

// Items with no thumbnail (Color is rendered as a swatch).
export const NO_IMAGE_ITEM_TYPES = ['Color'];
